import React from "react";
import {
  Paper,
  Typography,
  Box,
  Stack,
  Button,
} from "@mui/material";
import PolicyBadges from "../../pages/vendor/PolicyBadges";

const BuyBox = ({
  price,
  inStock,
  stock,
  pincode,
  setPincode,
  deliveryEta,
  setDeliveryEta,
  qty,
  setQty,
  handleAddToCart,
  handleBuyNow,
  product,
  badges,
  navigate,
  businessName,
  vendor,
  vendorName,
}) => {
  return (
    <Paper
      sx={{
        p: 3,
        borderRadius: 3,
        position: { md: "sticky" },
        top: 80,
      }}
    >
      <Typography variant="h6" fontWeight={700}>
        ₹ {Number(price).toLocaleString("en-IN")}
      </Typography>

      <Box
        sx={{
          mt: 2,
          mb: 2,
          p: 1,
          fontWeight: 600,
          borderRadius: 1,
          bgcolor: !inStock
            ? "#fdecea"
            : stock <= 3
            ? "#fff4e5"
            : "#e6f4ea",
          color: !inStock
            ? "#b71c1c"
            : stock <= 3
            ? "#e65100"
            : "#1b5e20",
        }}
      >
        {!inStock
          ? "Currently Unavailable"
          : stock <= 3
          ? `Only ${stock} left in stock!`
          : "In Stock"}
      </Box>

      <PolicyBadges badges={badges} singleLine={true} />

      <Stack spacing={1.5} sx={{ mt: 2 }}>
        {/* Quantity Selector */}
        {inStock && (
          <Box sx={{ mt: 2 }}>
            <Typography fontWeight={600} mb={0.5}>
              Quantity:
            </Typography>

            <select
              value={qty}
              onChange={(e) => setQty(Number(e.target.value))}
              style={{
                width: "100%",
                padding: "8px",
                borderRadius: 4,
                border: "1px solid #ccc",
                background: "#f0f2f2",
                cursor: "pointer",
              }}
            >
              {[...Array(Math.min(stock, 10))].map((_, i) => (
                <option key={i + 1} value={i + 1}>
                  {i + 1}
                </option>
              ))}
            </select>

            {stock <= 3 && (
              <Typography
                variant="caption"
                sx={{ display: "block", mt: 1, color: "#e65100" }}
              >
                Only {stock} left in stock!
              </Typography>
            )}
          </Box>
        )}

        <Box sx={{ mt: 2 }}>
          <Typography fontWeight={600}>Delivery</Typography>
          <Stack direction="row" spacing={1} sx={{ mt: 1 }}>
            <input
              value={pincode}
              maxLength={6}
              onChange={(e) => setPincode(e.target.value)}
              placeholder="Enter pincode"
              style={{ flex: 1, padding: 8 }}
            />
            <Button
              size="small"
              onClick={() =>
                pincode.length === 6 &&
                setDeliveryEta("Delivery by Tomorrow")
              }
            >
              Check
            </Button>
          </Stack>
          {deliveryEta && (
            <Typography variant="caption" color="green">
              {deliveryEta}
            </Typography>
          )}
        </Box>

        <Button
          type="button"
          variant="contained"
          disabled={!inStock}
          sx={{
            bgcolor: "#ffd814",
            color: "#000",
            fontWeight: 600,
            opacity: !inStock ? 0.6 : 1,
          }}
          onClick={handleAddToCart}
        >
          Add to Cart
        </Button>

        <Button
          variant="contained"
          disabled={!inStock}
          sx={{
            bgcolor: "#ffa41c",
            color: "#000",
            fontWeight: 600,
            opacity: !inStock ? 0.6 : 1,
          }}
          onClick={handleBuyNow}
        >
          Buy Now
        </Button>
      </Stack>

      <Typography variant="caption" sx={{ mt: 2, display: "block" }}>
        Sold by{" "}
        <span
          onClick={() => navigate(`/store/${product.vendorId}`)}
          style={{
            color: "#007185",
            cursor: "pointer",
            fontWeight: 600,
          }}
        >
          {businessName ||
            vendor?.store?.businessName ||
            vendor?.businessName ||
            product?.vendor?.businessName ||
            vendorName}
        </span>
      </Typography>
    </Paper>
  );
};

export default BuyBox;